import styled from 'styled-components';

import { Image } from 'components/Image';

const Container = styled.div`
  position: relative;

  display: flex;

  padding-bottom: 3rem;

  input {
    width: 8rem;
  }
`;

const ImageContainer = styled.div`
  width: 25rem;
`;

const Img = styled(Image)`
  width: 22rem;
  margin-left: 1.2rem;
`;

export { Container, ImageContainer, Img };
